/**
 * Apply masonry layout
 */
$(window).on('load', function() {
    $('.page-work-grid .grid').packery();
});
